import React, { useState, useCallback } from 'react'
import { Helmet } from 'react-helmet-async'
import { AdminMenu } from '../../component/admin/AdminMenu'
import { AdminXsMenu } from '../../component/admin/AdminXsMenu'
import { Box, Typography, Button, TextField } from '@mui/material'
import { Navbar } from '../../component/shared/Navbar'
import AddIcon from '@mui/icons-material/Add'
import Table from './Table'
import { debounce } from 'lodash'

export const CompanyMappingScreen = () => {
  const [open, setOpen] = useState(false)
  const [searchKey, setSearchKey] = useState('')

  const handleSearch = useCallback(
    debounce((value) => {
      setSearchKey(value)
    }, 500),
    []
  )

  return (
    <>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>Company Mapping</title>
      </Helmet>
      <Navbar />
      <Box display={{ xs: 'block', md: 'flex' }}>
        <AdminMenu />
        <Box
          overflow='hidden'
          boxSizing='border-box'
          width='100%'
          sx={{ p: { xs: 1 } }}
          mb={{ xs: 2, md: 10 }}
        >
          <Box display='flex' my={3} justifyContent='space-between'>
            <Typography variant='h1'>Company Mapping</Typography>
            <AdminXsMenu />
          </Box>
          <Box gap={2} display='flex' mb={3}>
            <TextField
              label='Search'
              variant='outlined'
              onChange={(e) => handleSearch(e.target.value)}
              placeholder='Company Name / Id'
              fullWidth
            />
            <Button
              startIcon={<AddIcon style={{ color: 'white' }} />}
              variant='contained'
              color='primary'
              onClick={() => setOpen(true)}
            >
              Create
            </Button>
          </Box>
          <Table open={open} setOpen={setOpen} searchKey={searchKey} />
        </Box>
      </Box>
    </>
  )
}
